import React from "react";
import { Row, Col } from "react-bootstrap";
import "./About.css";

const About = () => {
  return (
    <main>
      <section className="about">
        <Row className="container">
          <Col xs={12} md={6} className="section-title">
            <div className="about-img">
              <img src="about-img.jpg" alt="About page" />
            </div>
          </Col>

          <Col xs={12} md={6} className="about-content grid">
            <div className="about-text">
              <h2 className="about-title fs-26 ls-1">About Food <span className="spot-design">Spot</span> </h2>
              <p className="fs-17">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Accusamus dignissimos consequuntur vero commodi provident
                maiores, iusto atque corrupti voluptate vel sequi consectetur
                unde aliquam corporis saepe animi non, tempora reiciendis
                molestias sed laudantium dolores. Assumenda aperiam fuga quo
                voluptate commodi ullam aliquam expedita voluptas delectus.
              </p>
              <p className="fs-17">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor,
                dicta, possimus inventore eveniet atque voluptatibus repellendus
                aspernatur illo aliquam dignissimos illum. Commodi, porro omnis
                dolore amet neque modi quas eum!
              </p>
            </div>
          </Col>
        </Row>
      </section>
    </main>
  );
};

export default About;
